// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"a3e7f83b","178":"7b18dc34","216":"7f4c6112","304":"24514997","376":"50e08071","453":"9dce8499","798":"c94fa7ac","827":"3360b89e","856":"0e2fe72f","887":"c219fedb","946":"fb5355ad"}[chunkId] + ".chunk.js";
};